<template>
  <div
    class="bg-background-neutral-secondary flex items-start space-x-2 rounded-2xl p-4"
  >
    <img src="@/assets/images/note.svg" width="24" height="24" alt="" />
    <p class="text-text-neutral-tertiary text-sm font-medium">
      {{ $t('details.warnings.improveFare') }}
    </p>
  </div>
</template>
